import { AUTOPAY_BUSINESS_ERROR_CODE, DELETE_PAYMENT_METHOD_ERROR_CODE, PAYMENT_BUSINESS_ERROR_CODE, PAYMENT_METHOD_BUSINESS_ERROR_CODE } from '../const/errorCode';
const isPaymentMethodErrorCode = (businessErrorCode) => {
    const paymentMethodBusinessErrors = Object.values(PAYMENT_METHOD_BUSINESS_ERROR_CODE);
    const paymentMethodBusinessErrorCodes = [
        ...paymentMethodBusinessErrors,
        PAYMENT_BUSINESS_ERROR_CODE.PAYMENT_METHOD_UNAUTHORIZED,
        PAYMENT_BUSINESS_ERROR_CODE.PAYMENT_METHOD_EXPIRATION_INVALID,
        PAYMENT_BUSINESS_ERROR_CODE.PAYMENT_METHOD_ROUTING_INVALID,
        PAYMENT_BUSINESS_ERROR_CODE.PAYMENT_METHOD_CARD_INVALID,
        PAYMENT_BUSINESS_ERROR_CODE.PAYMENT_METHOD_ACCOUNT_INVALID,
        PAYMENT_BUSINESS_ERROR_CODE.PAYMENT_METHOD_TYPE_INVALID,
        PAYMENT_BUSINESS_ERROR_CODE.PAYMENT_METHOD_ACCOUNT_LOCKED,
        AUTOPAY_BUSINESS_ERROR_CODE.PAYMENT_METHOD_UNAUTHORIZED,
        AUTOPAY_BUSINESS_ERROR_CODE.PAYMENT_METHOD_ROUTING_INVALID,
        AUTOPAY_BUSINESS_ERROR_CODE.PAYMENT_METHOD_CARD_INVALID,
        AUTOPAY_BUSINESS_ERROR_CODE.PAYMENT_METHOD_UPDATE_RESTRICTED,
        AUTOPAY_BUSINESS_ERROR_CODE.PAYMENT_METHOD_ACCOUNT_INVALID,
        AUTOPAY_BUSINESS_ERROR_CODE.PAYMENT_METHOD_TYPE_INVALID,
        AUTOPAY_BUSINESS_ERROR_CODE.PAYMENT_METHOD_ACCOUNT_LOCKED,
        DELETE_PAYMENT_METHOD_ERROR_CODE.PAYMENT_METHOD_AUTOPAY_EXISTS,
        DELETE_PAYMENT_METHOD_ERROR_CODE.PAYMENT_METHOD_PAYMENT_SCHEDULED
    ];
    return paymentMethodBusinessErrorCodes.includes(businessErrorCode);
};
export default isPaymentMethodErrorCode;
